namespace ui
{
	export namespace type
	{
		export type TBorderStyleSingle =	'none' | 'hidden' | 'dotted' |
																		'dashed' | 'solid' | 'double' |
																		'groove' | 'ridge' | 'inset' |
																		'outset' | 'initial' | 'inherit';

		export type TBorderRadius = string;

		export interface IBorderSetting
		{
			width: string;
			style: TBorderStyleSingle;
			color: string;
			radius: TBorderRadius;
		}
	}
}
